export default __webpack_public_path__ + "static/media/warning.2ef80d09.svg";